<template>
    <div class="wrap-content ocr-config-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-12">
                    <h2>Variant Words</h2>
                </div>
            </div>
        </div>
        <div
            v-if="!showPageLoader"
            class="config-card-switch sar-configuration"
        >
            <div class="row">
                <div class="col-lg-12">
                    <div class="">
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <div v-if="doVariantWords == true">
                                    <div class="row">
                                        <div
                                            v-show="
                                                useCustomKeywordsAM == false
                                            "
                                            class="col-md-12"
                                        >
                                            <div
                                                :class="[
                                                    '',
                                                    'tablet-table-small-min-width',
                                                    'mobile-table-responsive-xlg',
                                                    {
                                                        'overflow-hidden':
                                                            !data.length &&
                                                            !showPageLoader,
                                                    },
                                                ]"
                                            >
                                                <div
                                                    class="d-flex justify-content-end my-2"
                                                >
                                                    <base-button
                                                        btn-label="Add Variant Words"
                                                        btn-type="submit"
                                                        btn-variant="primary"
                                                        @click="
                                                            $bvModal.show(
                                                                'modify-Variant-popup'
                                                            )
                                                        "
                                                    ></base-button>
                                                </div>
                                                <b-table
                                                    ref="userAdminVueTable"
                                                    :items="data"
                                                    :fields="fields"
                                                    no-local-sorting
                                                    @sort-changed="
                                                        sortingChanged
                                                    "
                                                >
                                                    <template
                                                        slot="keyword"
                                                        slot-scope="data"
                                                    >
                                                        <button class="button">
                                                            {{
                                                                data.item
                                                                    .keyword
                                                            }}
                                                        </button>
                                                    </template>
                                                    <template
                                                        slot="variant_1"
                                                        slot-scope="data"
                                                    >
                                                        <button class="button1" v-if="data.item
                                                                    .variants
                                                                    .length > 0">
                                                            {{
                                                                data.item
                                                                    .variants
                                                                    .length > 0
                                                                    ? data.item
                                                                          .variants[0]
                                                                          .keyword
                                                                    : 'N/A'
                                                            }}
                                                        </button>
                                                        <p v-else> </p>
                                                    </template>
                                                    <template
                                                        slot="variant_2"
                                                        slot-scope="data"
                                                    >
                                                        <button class="button1" v-if="data.item
                                                                    .variants
                                                                    .length > 1">
                                                            {{
                                                                data.item
                                                                    .variants
                                                                    .length > 1
                                                                    ? data.item
                                                                          .variants[1]
                                                                          .keyword
                                                                    : 'N/A'
                                                            }}
                                                        </button>
                                                         <p v-else> </p>
                                                    </template>
                                                    <template
                                                        slot="variant_3"
                                                        slot-scope="data"
                                                    >
                                                        <button class="button1" v-if="data.item
                                                                    .variants
                                                                    .length > 2">
                                                            {{
                                                                data.item
                                                                    .variants
                                                                    .length > 2
                                                                    ? data.item
                                                                          .variants[2]
                                                                          .keyword
                                                                    : 'N/A'
                                                            }}
                                                        </button>
                                                         <p v-else> </p>
                                                    </template>
                                                    <template
                                                        slot="status"
                                                        slot-scope="data"
                                                    >
                                                        <div
                                                            class="action-review"
                                                        >
                                                            <!-- if action modify -->
                                                            <base-action
                                                                icon="icon-edit"
                                                                label="Modify"
                                                                @click="
                                                                    selectedRecord(
                                                                        data.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'modify-Variant-popup'
                                                                    )
                                                                "
                                                            ></base-action>

                                                            <base-action
                                                                :icon="
                                                                    data.item
                                                                        .status ==
                                                                    'active'
                                                                        ? 'icon-trash'
                                                                        : 'icon-done'
                                                                "
                                                                :label="
                                                                    data.item
                                                                        .status ==
                                                                    'active'
                                                                        ? 'Archive'
                                                                        : 'Activate'
                                                                "
                                                                @click="
                                                                    selectedRecord(
                                                                        data.item
                                                                    )
                                                                    $bvModal.show(
                                                                        'status-update-popup'
                                                                    )
                                                                "
                                                            ></base-action>
                                                        </div>
                                                    </template>
                                                </b-table>
                                                <!-- When data is loading -->
                                                <!-- <base-table-spinner
                                                    v-if="
                                                        !data.length &&
                                                        !showPageLoader
                                                    "
                                                ></base-table-spinner> -->
                                            </div>
                                            <base-records
                                                path="configurations/variant-words"
                                                :query="query"
                                                :show-pagination="true"
                                                :reset="reset"
                                            ></base-records>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <status-update-popup></status-update-popup>
                    <modify-Variant-popup></modify-Variant-popup>
                </div>
                <!--  When data is loading -->
                <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            </div>
        </div>
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import ModifyVariantPopup from '../../../components/popups/ModifyVariantPopup.vue'
const sarApi = new resource('configurations/sar')
export default {
    // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    name: 'AddRemove',
    components: {
        ModifyVariantPopup,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > data
    props: ['username'],
    data() {
        return {
            useCustomKeywordsAM: false,
            showPageLoader: true,
            doVariantWords: true,
            fields: [
                {
                    key: 'keyword',
                    label: 'keywords',
                    sortable: false,
                    tdClass: 'items_bin_score_field',
                },
                {
                    key: 'variant_1',
                    label: 'Variant 1',
                    sortable: false,
                    tdClass: 'items_bin_score_field',
                },
                {
                    key: 'variant_2',
                    label: 'Variant 2',
                    sortable: false,
                    tdClass: 'items_bin_score_field',
                },
                {
                    key: 'variant_3',
                    label: 'Variant 3',
                    sortable: false,
                    tdClass: 'items_bin_score_field',
                },
                {
                    key: 'status',
                    label: 'Action',
                    tdClass: 'items_bin_score_field',
                    sortable: false,
                },
            ],
            query: {
                startAt: 1,
                keyword: '',
                perPage: 10,
                roleId: null,
                dataSegmentId: null,
                status: null,
                sortBy: 'keyword',
                sortOrder: 'asc',
            },
            title: '',
            buttonText: '',
            selectAll: false,
            reset: new Date().getTime(),
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['data', 'dataSegmentId', 'loading']),
        selected() {
            return this.list.modules.filter((module) => module.selected)
        },
    }, // End of Component > computed
    watch: {
        dataSegmentId(value) {
            console.log('the watch are', value)
            if (value) {
                this.getSarData()
            }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getSarData()
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        sortingChanged(ctx) {
            // ctx.sortBy   ==> Field key for sorting by (or null for no sorting)
            this.query.sortBy = ctx.sortBy
            // ctx.sortDesc ==> true if sorting descending, false otherwise
            this.query.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.apply()
            this.$store.commit('setLoading', false)
        }, // End of sortingChanged() method

        apply() {
            this.$store.commit('setLoading', true)
            this.reset = new Date().getTime()
        },

        selectedRecord(record) {
            console.log('record', record)
            this.$store.commit('setItem', record)
        }, // End of selectedRecord() method

        select() {
            this.selected = []
            console.log('t or f', this.selectAll)
            if (!this.selectAll) {
                this.items.forEach((item) => {
                    console.log('item', item)
                    this.selected.push(item)
                })
                console.log('selected', this.selected)
            }
            this.selectAll = !this.selectAll
        },
        async getSarData() {
            try {
                if (this.dataSegmentId) {
                    let { data } = await sarApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    console.log('DATAAAA', data.data)
                    if (!_.isEmpty(data.data)) {
                        this.formData = data.data
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                useCustomKeywordsAM
                this.showPageLoader = false
            }
        },
    },
} // End of export default
</script>
<style>
.container {
    width: 300px;
    height: 150px;
    overflow-y: scroll;
}

/* .button {
    background-color: #45ee23;
    border: none;
    color: black;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
} */
.button {
    background-color: #28a745;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button:hover {
    background-color: #28a745;
}

/* .button1 {
    background-color: #ec931e;
    border: none;
    color: black;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
} */
.button1 {
    background-color: #f4c200;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button1:hover {
    background-color: #f4c200;
}

.button2 {
    background-color: #5ddfbed2;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button3 {
    background-color: #ec4848e0;
    border: none;
    color: #fff;
    min-width: 120px;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 16px;
}

.button3:hover {
    background-color: #ec4848e0;
}

.items_bin_score_field {
    white-space: nowrap;
    width: 1%;
}

#myinput {
    background: linear-gradient(to right, #eb5ad7 0%, #eb5ad7 100%);
    border-radius: 8px;
    height: 7px;
    width: 356px;
}
</style>
